import { TransactionNodeType } from './contract-object.types';

//TODO:  This is a temporary action to load the entire state from data already retrieved.
// This will be changed to actually retrieve the data and normalize it.
export class SetContractObjectState {
    static readonly type = '[Contract] Set Contract Object State';
    constructor(public entities: any) { }
}

export class ResetState {
    static readonly type = '[Contract] Reset State';
    constructor() { }
}

//TODO: Move this to an shared state object for all transactions?
export class PrepareRequest {
    static readonly type = '[Contract] Prepare Request';
    constructor(public tranOptions: any) { }
}

export class InitializeTransaction {
    static readonly type = '[Contract] Initialize Transaction';
    constructor(public transactionType: TransactionNodeType) { }
}

export class AddDefaultLocation {
    static readonly type = '[Contract] Add Default Location';
    constructor() { }
}

export class SyncBrokerPartyFromContractBroker {
    static readonly type = '[Contract] Sync Broker Party From Contract Broker';
    constructor(public prevParty: any, public newParty: any) { }
}

export class SyncBrokerPartyAffiliateFromContractBrokerAffiliate {
    static readonly type = '[Contract] Sync Broker Party Affiliate From Contract Broker Affiliate';
    constructor(public newAffiliate: any, public broker: any) { }
}

export class LinkProfileToArticle {
    static readonly type = '[Contract] Link Profile To Article';
    constructor(public profileID: number, public articleID: number) { }
}

export class DeleteArticlesLinkedToProfile {
    static readonly type = '[Contract] Delete Articles Linked To Profile';
    constructor(public profileID: number) { }
}

export class AddNewProfileForClonedArticle {
    static readonly type = '[Contract] Add New Profile For Cloned Article';
    constructor(public article: any) { }
}

export class SyncProcedureEstFullTermPrem {
    static readonly type = '[Contract] Sync Procedure EstFullTermPrem';
    constructor(public amount: any) { }
}

export class SelfAuditCalculateReporting {
    static readonly type = '[Contract] SelfAudit Calculate Reporting';
    constructor(public calcType: string, public calcPct: string, public round: boolean) { }
}
